// Inicio, "Lo que conocemos" (negocio), "Tu estrategia" y "Tus redes hoy".
export default {
  // Nombres de los pasos (GRUPOS en pantallas/marca.tsx), que el inicio enseña en "Lo que sigue" y "Seguir con".
  'Lo que conocemos': 'What we know',
  'Tu estrategia': 'Your strategy',
  'Tus redes hoy': 'Your social media today',
  'Tu identidad': 'Your look',
  'Tu presentadora': 'Your presenter',
  'Plan del mes': "Month's plan",
  // También es el formato "solo texto" en Tus redes hoy: "Text" sirve para los dos.
  Textos: 'Text',
  Diseños: 'Designs',
  Videos: 'Videos',

  // Formatos
  Reel: 'Reel',
  Carrusel: 'Carousel',
  Imagen: 'Image',
  Reels: 'Reels',
  Carruseles: 'Carousels',
  Imágenes: 'Images',

  // Inicio
  '¡Hola!': 'Hi!',
  '¡Hola, {nombre}!': 'Hi, {nombre}!',
  'Así va {marca} este mes.': "Here's how {marca} is doing this month.",
  'tu marca': 'your brand',
  'Diseño de tu próxima publicación': 'Design for your next post',
  'Tu próxima publicación': 'Your next post',
  Publicación: 'Post',
  Ver: 'View',
  Prepararla: 'Get it ready',
  'Tu mes': 'Your month',
  'Ya pasaron todas las fechas de este plan': 'All the dates in this plan have passed',
  'Planifiquemos tu mes': "Let's plan your month",
  'Lo que sigue: {paso}': 'Up next: {paso}',
  'Todo al día': 'All caught up',
  Empezar: 'Start',
  'Cada cuadro es una publicación. Se rellena cuando ya tiene su diseño o su video.':
    'Each square is a post. It fills in once it has its design or video.',
  'Aquí verás tus publicaciones cuando armes el plan del mes.': "You'll see your posts here once you build the month's plan.",
  '¡Mes listo!': 'Month ready!',
  '/{total} listas': '/{total} ready',
  'Tus créditos': 'Your credits',
  disponibles: 'available',
  'Te alcanzan para unos:': "That's enough for about:",
  imágenes: 'images',
  carruseles: 'carousels',
  reels: 'reels',
  'Tu marca': 'Your brand',
  '/{total} pasos': '/{total} steps',
  'Seguir con {paso}': 'Continue with {paso}',
  'Todo listo. ¡Buen trabajo!': 'All done. Great job!',
  'Tip del día': 'Tip of the day',
  'Tip anterior': 'Previous tip',
  'Siguiente tip': 'Next tip',

  // Consejos del día (TIPS)
  'Responde en la primera hora': 'Reply within the first hour',
  'Es cuando más gente está viendo tu publicación, y cada respuesta la mueve más.':
    "That's when the most people are seeing your post, and every reply pushes it further.",
  'Los 3 primeros segundos mandan': 'The first 3 seconds rule',
  'Empieza tu reel por lo más interesante, no por el saludo.': 'Open your reel with the most interesting part, not a hello.',
  'Luz de ventana, siempre': 'Window light, always',
  'Una foto de tu producto con luz natural vale más que diez con flash.':
    'One photo of your product in natural light beats ten with flash.',
  'Tus mensajes son ideas': 'Your messages are ideas',
  'Guarda las preguntas que te hacen: cada una es una publicación que ya sabes que interesa.':
    "Save the questions people ask you: each one is a post you already know they care about.",
  'Di qué quieres que hagan': 'Tell them what to do',
  'Cierra cada publicación con una acción: escribir, guardar, compartir o visitar.':
    'End every post with an action: message, save, share or visit.',
  'Constancia antes que cantidad': 'Consistency over quantity',
  'Tres veces por semana, todas las semanas, gana a diez un mes y nada el siguiente.':
    'Three times a week, every week, beats ten one month and nothing the next.',
  'Muestra a tu equipo': 'Show your team',
  'La gente le compra a gente. Deja ver quién está detrás de tu negocio.':
    "People buy from people. Let them see who's behind your business.",
  'Enseña algo útil': 'Teach something useful',
  'Un carrusel que enseña se guarda y se comparte: es el que más te hace crecer.':
    'A carousel that teaches gets saved and shared: it grows your account the most.',
  'Repite lo que funcionó': 'Repeat what worked',
  'Mira qué publicación te trajo más mensajes este mes y haz otra parecida.':
    'See which post brought you the most messages this month and make another one like it.',
  'Subtítulos en todo': 'Captions on everything',
  'La mayoría ve los videos sin sonido. Si no hay texto, no se entiende.':
    "Most people watch videos with the sound off. Without text, they won't get it.",
  'Nadie quiere esperar': 'Nobody likes to wait',
  'Contesta los mensajes aunque sea con un "ya te respondo".': 'Answer messages, even if it\'s just "I\'ll get back to you soon."',
  'Pide una reseña': 'Ask for a review',
  'Un cliente feliz que cuenta su experiencia vale más que cualquier anuncio.':
    'A happy customer sharing their experience is worth more than any ad.',
  'Historias y feed, cada uno a lo suyo': 'Stories and feed, each for its own thing',
  'Las historias para el día a día; el feed para lo que quieres que dure.':
    'Stories for the day-to-day; the feed for what you want to last.',
  'Léelo en voz alta': 'Read it out loud',
  'Si suena raro dicho, suena raro escrito. Ajústalo antes de publicar.':
    'If it sounds odd out loud, it reads odd too. Fix it before you post.',
  'Pon el precio': 'Show the price',
  'Un precio claro te ahorra muchos mensajes de "¿cuánto vale?".': 'A clear price saves you lots of "how much is it?" messages.',
  'Cuenta el antes y el después': 'Show the before and after',
  'La gente entiende mejor un cambio que una lista de beneficios.': 'People get a change faster than a list of benefits.',
  'Fija lo mejor arriba': 'Pin your best posts',
  'Deja en tu perfil las tres publicaciones que mejor explican lo que haces.':
    'Pin the three posts that best explain what you do to the top of your profile.',
  'Las fechas de tu ciudad': "Your city's special days",
  'Aprovecha las celebraciones locales, no solo las del calendario.': 'Make the most of local celebrations, not just the usual holidays.',
  'Cambia el comienzo': 'Change the opening',
  'Si algo no funcionó, prueba otro inicio antes de rehacerlo todo.': "If something didn't work, try a new opening before redoing it all.",
  'Una biografía que vende': 'A bio that sells',
  'Qué haces, para quién y cómo contactarte. En ese orden.': 'What you do, who it\'s for and how to reach you. In that order.',
  'Vertical y de cerca': 'Vertical and up close',
  'En el celular, lo pequeño no se ve. Acércate a lo que importa.': "On a phone, small things get lost. Get close to what matters.",
  'Comenta en otras cuentas': 'Comment on other accounts',
  'Hablar con tus clientes y vecinos en sus publicaciones también es hacer comunidad.':
    'Chatting with your customers and neighbors on their posts builds community too.',
  'Pregunta antes de lanzar': 'Ask before you launch',
  'Las preguntas en historias te dicen qué le importa a tu gente.': 'Questions in your stories tell you what your people care about.',
  'Menos redes, mejor atendidas': 'Fewer networks, better cared for',
  'Dos redes bien cuidadas valen más que cinco abandonadas.': 'Two well-kept accounts are worth more than five abandoned ones.',
  'Tu público no lo vio todo': "Your audience didn't see it all",
  'Repetir una idea que funcionó no aburre: la mayoría no la vio la primera vez.':
    "Repeating an idea that worked isn't boring: most people missed it the first time.",
  'Enseña el proceso': 'Show the process',
  'Mostrar cómo haces tu producto o tu servicio genera confianza.': 'Showing how you make your product or deliver your service builds trust.',
  'La primera línea es el título': 'The first line is the headline',
  'Si engancha, leen el resto del texto.': "If it hooks them, they'll read the rest.",
  'Tus números, una vez por semana': 'Check your numbers once a week',
  'Así ves la tendencia y no te angustia el día a día.': "That way you see the trend and don't stress over every day.",
  'Agradece en público': 'Say thanks in public',
  'Mencionar a quien te recomienda invita a que otros lo hagan.': 'Shouting out people who recommend you encourages others to do the same.',
  'Lo obvio para ti, sorprende': 'What seems obvious to you surprises others',
  'Lo que das por sabido de tu negocio puede ser justo lo que tu cliente no sabe.':
    "What you take for granted about your business may be exactly what your customer doesn't know.",

  // Lo que conocemos (negocio)
  'Cuéntanos de tu negocio y revisamos tus redes para entenderlo.': "Tell us about your business and we'll look at your social media to understand it.",
  'Nombre del negocio': 'Business name',
  'Tu Instagram': 'Your Instagram',
  opcional: 'optional',
  '@tunegocio': '@yourbusiness',
  'Tu página web': 'Your website',
  'tunegocio.com': 'yourbusiness.com',
  '¿Qué vendes?': 'What do you sell?',
  'Café de origen y pastelería': 'Specialty coffee and pastries',
  '¿A quién le vendes?': 'Who do you sell to?',
  'Gente del barrio que trabaja desde casa': 'Neighborhood folks who work from home',
  '¿Qué te hace diferente?': 'What makes you different?',
  'Tostamos nosotros mismos cada semana': 'We roast our own beans every week',
  '¿En qué país o ciudad estás?': 'What country or city are you in?',
  'Bogotá, Colombia': 'Bogotá, Colombia',
  '¿Qué quieres lograr con tus redes?': 'What do you want to achieve with your social media?',
  'Que lleguen más clientes al local': 'Get more customers into the store',
  '¿Cómo le hablas a tus clientes?': 'How do you talk to your customers?',
  Tú: 'Informal (tú)',
  Usted: 'Formal (usted)',
  Vos: 'Regional (vos)',
  'Analizar mi negocio': 'Analyze my business',
  País: 'Country',
  Idioma: 'Language',
  'Tipo de negocio': 'Type of business',
  'Publicidad regulada': 'Regulated advertising',
  'Sí · {categoria}': 'Yes · {categoria}',
  No: 'No',
  'Así entendimos tu negocio': "Here's how we understood your business",
  Producto: 'Product',
  Productos: 'Products',
  Diferencias: 'What sets you apart',
  'Por confirmar': 'To confirm',
  'Lo que te hace diferente': 'What makes you different',
  'Lo que vendes': 'What you sell',
  'Lo que vendes · {n}': 'What you sell · {n}',
  'Tu forma de hablar': 'How you talk',
  'Nos falta saber': 'We still need to know',
  Importante: 'Important',
  Útil: 'Helpful',
  'Su personalidad': 'Its personality',
  'Cómo trata a sus clientes': 'How it addresses customers',
  Emojis: 'Emojis',
  Ninguno: 'None',
  'Con moderación': 'In moderation',
  Muchos: 'Lots',
  'Así sí': 'Do say',
  'Así no': "Don't say",
  'Lo que gana tu cliente': 'What your customer gets',
  'Cómo es': "What it's like",
  'Sus dudas': 'Their doubts',
  'Sin precio todavía': 'No price yet',
  Principal: 'Main',
  'Cómo funciona': 'How it works',
  // Países
  Colombia: 'Colombia',
  México: 'Mexico',
  Argentina: 'Argentina',
  Chile: 'Chile',
  Perú: 'Peru',
  Uruguay: 'Uruguay',
  Ecuador: 'Ecuador',
  España: 'Spain',
  'Estados Unidos': 'United States',
  // Variantes del español
  'Español de Colombia': 'Colombian Spanish',
  'Español de México': 'Mexican Spanish',
  'Español de Argentina': 'Argentine Spanish',
  'Español de Chile': 'Chilean Spanish',
  'Español de Perú': 'Peruvian Spanish',
  'Español neutro': 'Neutral Spanish',
  // Tipos de negocio y de producto
  'Producto físico': 'Physical product',
  'Tienda en línea': 'Online store',
  Restaurante: 'Restaurant',
  'Servicio local': 'Local service',
  'Servicio profesional': 'Professional service',
  Infoproducto: 'Digital product',
  'Software o app': 'Software or app',
  Servicio: 'Service',
  Software: 'Software',
  Experiencia: 'Experience',

  // Tu estrategia
  'Definimos a quién le hablas, qué le duele y de qué vas a hablar cada mes.':
    "We figure out who you're talking to, what bothers them and what you'll talk about each month.",
  'Con lo que ya sabemos de tu negocio armamos a quién le hablas y de qué vas a hablar.':
    "With what we already know about your business, we'll map out who you're talking to and what you'll talk about.",
  'Crear mi estrategia': 'Create my strategy',
  'Tarda unos 2 minutos. Vale la pena.': "Takes about 2 minutes. It's worth it.",
  'Clientes ideales': 'Ideal customers',
  'A quién le hablas': "Who you're talking to",
  'Cosas que siente': 'What they feel',
  'Dolores, miedos y deseos': 'Pains, fears and wishes',
  'Ideas ganadoras': 'Winning ideas',
  'Listas para usar': 'Ready to use',
  'Temas del mes': "Month's topics",
  'De qué vas a hablar': "What you'll talk about",
  'Tu mercado': 'Your market',
  'Qué tanto sabe ya tu cliente': 'How much your customer already knows',
  'No sabe que tiene el problema': "Doesn't know they have the problem",
  'Sabe que tiene un problema': 'Knows they have a problem',
  'Conoce soluciones': 'Knows about solutions',
  'Ya te conoce': 'Already knows you',
  'Listo para comprar': 'Ready to buy',
  'Tu cliente': 'Your customer',
  'Lo que siente': 'What they feel',
  'Tu propuesta': 'Your offer',
  Ideas: 'Ideas',
  'De qué hablar': 'What to talk about',
  'Tu voz': 'Your voice',
  'Dónde está': 'Where they are',
  'Cuándo compra': 'When they buy',
  'Le duele': 'What hurts',
  'Le da miedo': 'What scares them',
  Quiere: 'What they want',
  'Le frena': 'What holds them back',
  'Lo dicen así': 'In their own words',
  'Es nuestra hipótesis; con reseñas reales la afinamos.': "This is our best guess; we'll fine-tune it with real reviews.",
  'Todavía no está definida.': "It's not defined yet.",
  'El problema': 'The problem',
  'Lo que haces tú': 'What you do',
  Todas: 'All',
  Redes: 'Social media',
  Anuncios: 'Ads',
  'Las dos': 'Both',
  'Redes y anuncios': 'Social media and ads',
  '{n} idea': '{n} idea',
  '{n} ideas': '{n} ideas',
  Problema: 'Problem',
  Identidad: 'Identity',
  Beneficio: 'Benefit',
  'Resuelve dudas': 'Clears up doubts',
  Emoción: 'Emotion',
  Estatus: 'Status',
  Miedo: 'Fear',
  Comodidad: 'Convenience',
  Precio: 'Price',
  Comparación: 'Comparison',
  'Rompe mitos': 'Busts myths',
  Enseña: 'Teaches',
  Acerca: 'Brings closer',
  'Da confianza': 'Builds trust',
  Vende: 'Sells',
  'Cómo se reparte tu mes': 'How your month is split',
  'Así debes sonar': 'How you should sound',
  'Promesas que no debes hacer': "Promises you shouldn't make",
  'Todavía no hay guía de voz.': 'No voice guide yet.',

  // Tus redes hoy
  'Revisamos cómo te va para saber qué te funciona y qué conviene cambiar.':
    "We look at how you're doing to see what works for you and what's worth changing.",
  '+ Revisar otra red': '+ Check another network',
  '¿Qué redes revisamos?': 'Which networks should we check?',
  'Toca las que tienes y escribe tu cuenta.': 'Tap the ones you have and type your account.',
  'Página de Facebook': 'Facebook Page',
  'Tu usuario': 'Your username',
  'Dirección de tu página': 'Your page address',
  'Página de empresa o tu perfil personal': 'Company page or your personal profile',
  'facebook.com/tunegocio': 'facebook.com/yourbusiness',
  'linkedin.com/company/tunegocio': 'linkedin.com/company/yourbusiness',
  'Confirmo que este perfil de LinkedIn es mío y autorizo a IGOR a revisar sus publicaciones públicas para hacer mi diagnóstico.':
    'I confirm this LinkedIn profile is mine and I allow IGOR to review its public posts to make my assessment.',
  'Revisar mis redes': 'Check my social media',
  'Marca la casilla para revisar tu perfil': 'Check the box so we can review your profile',
  'Tarda alrededor de un minuto.': 'Takes about a minute.',
  'Tarda alrededor de un minuto · usa {creditos} créditos.': 'Takes about a minute · uses {creditos} credits.',
  'No encontramos datos de tus redes.': "We couldn't find data for your social media.",
  Interacción: 'Engagement',
  'de tus seguidores reacciona': 'of your followers engage',
  'Sin publicar': 'Since last post',
  días: 'days',
  '{n} publicaciones por semana': '{n} posts per week',
  'Qué te funciona mejor': 'What works best for you',
  'interacciones promedio por publicación': 'average interactions per post',
  '{n} publ.': '{n} posts',
  '{n} vistas': '{n} views',
  'Tu foco este mes': 'Your focus this month',
  'Tu próxima acción:': 'Your next step:',
  'Tu mezcla ideal': 'Your ideal mix',
  'por semana': 'per week',
  'Hoy publicas · te conviene': 'What you post · what works best',
  'Lo que publicas hoy': 'What you post today',
  'Lo que te conviene': "What's best for you",
  'Lo que haces bien': "What you're doing well",
  'Lo que te frena': "What's holding you back",
  Oportunidades: 'Opportunities',
  'Qué te recomendamos': 'What we recommend',
  'Qué hacer:': 'What to do:',
  'Tus publicaciones más fuertes': 'Your strongest posts',
  interacciones: 'interactions',
  vistas: 'views',
  'Ver publicación ›': 'View post ›',
  'Los hashtags que más usas': 'Your most-used hashtags',
  'Lo que nos faltó ver': "What we couldn't see",
  'Foto de perfil de @{usuario}': "@{usuario}'s profile picture",
  Seguidores: 'Followers',
  Revisadas: 'Reviewed',
  'Por semana': 'Per week',
  'Última publicación: {fecha}': 'Last post: {fecha}',
  'Revisada el {fecha}': 'Reviewed on {fecha}',
  'Pega todo lo que tengas': 'Paste everything you have',
  'Tu brief, la historia de tu marca, tus productos y precios, tu cliente ideal… Todo lo que sepas, sin ordenarlo.': 'Your brief, your brand story, your products and prices, your ideal customer… Everything you know, no need to organize it.',
  'Cambiar el PDF': 'Change the PDF',
  'O sube un PDF': 'Or upload a PDF',
  'El documento debe ser un PDF': 'The document must be a PDF',
  'El documento no puede pesar más de 20 MB': 'The document cannot be larger than 20 MB',
  'Una presentación, un brief o tu plan de negocio: lo leo entero y no te pregunto lo que ya diga ahí.': "A deck, a brief or your business plan: I read all of it and won't ask you what it already says.",
  'Subiendo tu documento…': 'Uploading your document…',
  "¿Ya tienes marca?": "Do you already have a brand?",
  "Sí, ya tengo marca": "Yes, I have a brand",
  "Todavía no: solo tengo la idea": "Not yet: I only have the idea",
  "Perfecto, empezamos desde cero: te propongo nombre, logo y colores, y no necesitas redes todavía.": "Great, we start from scratch: I'll suggest a name, logo and colors, and you don't need social media yet.",
  "¿Ya pensaste un nombre?": "Have you thought of a name?",
  "opcional: si lo dejas vacío, te propongo algunos": "optional: leave it empty and I'll suggest some",
  "¿Qué quieres vender?": "What do you want to sell?",
  "¿A quién le quieres vender?": "Who do you want to sell to?",
  "¿Qué te haría diferente?": "What would make you different?",
  "Ideas de nombre para tu marca": "Name ideas for your brand",
  "Por ahora usamos «{nombre}». Si te gusta otro, tócalo o escribe el tuyo.": "For now we use \"{nombre}\". If you like another, tap it or type your own.",
  "Otro nombre": "Another name",
  "Usar este": "Use this one",
  "Ya tengo redes: revisarlas": "I have social media now: review it",
  "Aún no tengo redes": "I don't have social media yet",
  "Tu marca empieza de cero en redes": "Your brand starts from zero on social media",
  "No hay nada que revisar todavía, y está bien: tu contenido se arma con tu estrategia. Cuando abras tus cuentas, vuelve aquí y te digo cómo te va.": "There's nothing to review yet, and that's fine: your content is built from your strategy. When you open your accounts, come back and I'll tell you how you're doing.",
  "Creemos tu identidad": "Let's create your identity",
  "Con lo que sé de tu negocio te propongo colores, letras y tres logos distintos. Eliges el que más te guste y lo puedes cambiar cuando quieras.": "With what I know about your business I'll suggest colors, fonts and three different logos. Pick the one you like best; you can change it anytime.",
  "¿Qué quieres que transmita tu marca?": "What should your brand convey?",
  "Cercana y alegre, colores cálidos, nada muy serio": "Friendly and cheerful, warm colors, nothing too serious",
  "Crear mi identidad": "Create my identity",
  "Sí tengo logo: subirlo": "I do have a logo: upload it",
  "Usa {creditos} créditos: el estilo y tres logos.": "Uses {creditos} credits: the style and three logos.",
  "¿Todavía no tienes logo ni identidad?": "Don't have a logo or identity yet?",
  "IGOR te la crea: colores, letras y tres logos para elegir.": "IGOR creates it for you: colors, fonts and three logos to choose from.",
  "Elige tu logo": "Choose your logo",
  "Toca el que más te guste. Si ninguno te convence, pide un cambio y te propongo otros.": "Tap the one you like best. If none convinces you, ask for a change and I'll suggest others.",
  "Logo {n}": "Logo {n}",
  "Este": "This one",
  "Por revisar": "To review",
  "Por hacer": "To do",
  "Tu producto": "Your product",
  "Todavía no nos has contado de tu negocio.": "You haven't told us about your business yet.",
  "Aprobada": "Approved",
  "{n} pilares: {pilares}.": "{n} pillars: {pilares}.",
  "Cliente: {quien}.": "Customer: {quien}.",
  "Todavía no hay estrategia.": "No strategy yet.",
  "Aún sin redes": "No social media yet",
  "Diagnóstico de {mes}": "{mes} diagnosis",
  "Tu marca empieza de cero en redes: el contenido parte de tu estrategia. Cuando abras tus cuentas, las revisamos.": "Your brand starts from zero on social media: content comes from your strategy. When you open your accounts, we review them.",
  "{red} con {n} seguidores.": "{red} with {n} followers.",
  "Todavía no hemos revisado tus redes.": "We haven't reviewed your social media yet.",
  "Tu branding": "Your branding",
  "Completo": "Complete",
  "Letras: {titulos} y {texto}.": "Fonts: {titulos} and {texto}.",
  "Todavía no hay identidad.": "No identity yet.",
  "Todo lo que IGOR sabe de {marca}. Se hace una vez y se ajusta cuando algo cambia.": "Everything IGOR knows about {marca}. Done once and adjusted when something changes.",
  "Ver o cambiar": "See or change",
} satisfies Record<string, string>;
